module.exports = __webpack_public_path__ + "static/img/guide_icon_tc.9b02ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide_icon_tc.png
// module id = Pvvq
// module chunks = 1